import { gql } from "@/services/httpAdapter";

export const onUserIngestion = gql`
	subscription onUserIngestion($locationId: String) {
		onUserIngestion(locationId: $locationId) {
			locationId
			activeUsersPositions
			inactiveUsersPositions
			unenrolledEmployeesPositions
		}
	}
`;
